import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import { LINKS } from '@/constants/links';
import MoreInfoSection from '@/sections/MoreInfo';
import React from 'react';
export function MoreInfo() {
  const $ = _c(30);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconDeferredPayment className="fillButtonIcon" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("core:products.deferredPayment");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = LINKS();
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = {
      analyticsParam: "gcssMoreInfoDeferredPayment",
      icon: t1,
      testId: "gcssMoreInfoDeferredPayment",
      title: t2,
      to: t3.deferredPayment
    };
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconMaxi className="fillButtonIcon" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("core:products.revolving");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = LINKS();
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6) {
    t8 = {
      analyticsParam: "gcssMoreInfoRevolving",
      icon: t5,
      testId: "gcssMoreInfoRevolving",
      title: t6,
      to: t7.revolving
    };
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <IconThird className="fillButtonIcon" />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t) {
    t10 = t("core:products.payInThree");
    $[14] = t;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = LINKS();
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10) {
    t12 = {
      analyticsParam: "gcssMoreInfoPayInThree",
      icon: t9,
      testId: "gcssMoreInfoPayInThree",
      title: t10,
      to: t11.payInThree
    };
    $[17] = t10;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <IconCard className="fillButtonIcon" />;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t) {
    t14 = t("core:products.card");
    $[20] = t;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = LINKS();
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t14) {
    t16 = {
      analyticsParam: "gcssMoreInfoCard",
      icon: t13,
      testId: "gcssMoreInfoCard",
      title: t14,
      to: t15.card
    };
    $[23] = t14;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t12 || $[26] !== t16 || $[27] !== t4 || $[28] !== t8) {
    t17 = <MoreInfoSection className="relative z-10 bg-blue-50 py-0! pb-14! md:pb-26!" buttons={[t4, t8, t12, t16]} />;
    $[25] = t12;
    $[26] = t16;
    $[27] = t4;
    $[28] = t8;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
}